import { Card, CardContent, CardMedia } from '@mui/material';
import Box from '@mui/material/Box';
import React, { useState } from 'react';
import { MyMLabel, MyMVariantLabel } from '../ui-elements/MyMLabel';
import { NavigateLink } from './NavigateLink';
import { useNavigate } from 'react-router-dom';

/**
 * OutlinedMediaLinkCard Component
 */
export const OutlinedMediaLinkCard = ({ screenId, navigateTo, navigateState, mediaHeight, mediaImageFileName, caption, descriptionHeight, description, children, onClick, descriptionMaxHeight
}) => {
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  // 2025.7.7 MyMine Version3.0対応 Modify Start
  const handleClick = (e) => {
    e.preventDefault(); 

    if (onClick) onClick(); 
    if (navigateTo) navigate(navigateTo, { state: navigateState }); 
  };
  /*2025.7.7 MyMine Version3.0対応 Modify End*/
  
  return (
    <NavigateLink
      to={navigateTo}
      navigateState={navigateState}
      underline="none"
      className="py-0 h-100 w-100"
      onClick={handleClick}
    >
      <Card
        variant="outlined"
        sx={{
          height: '100%',
          borderRadius: '10px',
        }}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Box position="relative" display="inline-block" width="100%" className="media-box">
          <CardMedia
            component="img"
            width="100%"
            sx={{
              height: mediaHeight,
              opacity: '0.5',
              zIndex: '30',
              visibility: hovered ? 'visible' : 'hidden',
            }}
            image={`${process.env.PUBLIC_URL}/${screenId}/${mediaImageFileName}`}
            alt={caption}
          />

          <Box
            position="absolute"
            top="0"
            left="0"
            color="white"
            padding="10px"
            height="100%"
            width="100%"
            sx={{
              backgroundColor: 'rgb(13 13 13 / 55%)',
              zIndex: '20',
            }}
          >
            <MyMVariantLabel
              variant="h4"
              position="absolute"
              top="50%"
              left="50%"
              textAlign="center"
              className="caption"
              sx={{
                transform: 'translate(-50%, -50%)',
                WebkitTransform: 'translate(-50%, -50%)',
                msTransform: 'translate(-50%, -50%)',
                width: '100%',
                fontSize: '1.3rem',
              }}
            >
              {caption}
            </MyMVariantLabel>
          </Box>
        </Box>
       {/* 2025.7.7 MyMine Version3.0対応 Modify Start*/}
        <CardContent
          sx={{
            paddingTop: '0px',
            paddingBottom: '6px !important',
            width: '100%',
            minHeight: descriptionHeight,
            maxHeight: descriptionMaxHeight
          }}
        >
          <MyMLabel sx={{ textAlign: 'left' }} className="description">
            {description}
          </MyMLabel>
          {/*2025.7.7 MyMine Version3.0対応 Modify End*/}
          {children && (
            // 2025.7.7 MyMine Version3.0対応 Modify Start
            <Box sx={{ textAlign: 'left' }} mt={1}>
              {/*2025.7.7 MyMine Version3.0対応 Modify End*/}
              {children}
            </Box>
          )}
        </CardContent>
      </Card>
    </NavigateLink>
  );
};
